import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  closeModal,
  formatTime,
  ToastMain,
  SweetAlertShow,
} from "../../master/Master";
import {
  addMonthSalary,
  salaryUpdate,
  workingSchedulesList,
  updateStaffEarnedSalary,
} from "../../../api/Staff";
import { getstaffwithid } from "../../../api/FacultyService";

import { useNavigate } from "react-router-dom";
import usePrivateLink from "../../config/usePrivateLink";

const SaleryInfoTab = () => {
  const hasAccess = usePrivateLink();

  const { id } = useParams();
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalData, setModalData] = useState("");
  const [workingSchedules, setWorkingSchedules] = useState([]);
  const [error, setError] = useState({});
  const [earnedSalaryData, setEarnedSalaryData] = useState({
    staff_id: "",
    staff_salary_id: "",
    new_earned_salary: "",
    old_earned_salary: "",
    old_working_days: "",
    new_working_days: "",
    old_present_days: "",
    new_present_days: "",
    remark: "",
  });

  const navigate = useNavigate();

  const AddMonthSalary = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError({});

    try {
      const formData = new FormData(e.target);

      const response = await addMonthSalary(formData);

      if (response.data.status) {
        closeModal("add_month_salary");

        ToastMain.fire({
          icon: "success",
          title: response.data.message || "Added Successfully",
        }).then(() => {
          staffFatch();
        });

        e.target.reset();
      } else {
        setError(response.data.errors || {});
      }
    } catch (err) {
      setError(err?.response?.data?.errors || {});
    } finally {
      setLoading(false);
    }
  };

  const getWorkingSchedule = async () => {
    setLoading(true);
    try {
      const response = await workingSchedulesList("");

      if (response?.data?.status) {
        setWorkingSchedules(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWorkingSchedule();
  }, []);

  // ✅ Staff fetch function
  const staffFatch = async () => {
    setLoading(true);
    try {
      const response = await getstaffwithid(id);
      if (response?.data?.status) {
        setTeacher(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSalaryChange = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await salaryUpdate(formData);
      if (response.data.status) {
        closeModal("salary_update");
        e.target.reset();
        ToastMain.fire({
          icon: "success",
          title: response?.data?.message || "successfully",
        }).then(() => {
          staffFatch();
        });
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEarnedSalaryUpdate = async (e) => {
    e.preventDefault();

    try {
      // Backend expects: staff_salary_id, new_earned_salary, working_days,
      // present_days, remark. old_* fields are display-only and staff_id
      // isn't used by the controller, so they're left out of the payload.
      const payload = {
        staff_salary_id: earnedSalaryData.staff_salary_id,
        new_earned_salary: earnedSalaryData.new_earned_salary,
        working_days: earnedSalaryData.new_working_days,
        present_days: earnedSalaryData.new_present_days,
        remark: earnedSalaryData.remark,
      };

      const response = await updateStaffEarnedSalary(payload);

      if (response.data.status) {
        closeModal("earned_salary_update");

        ToastMain.fire({
          icon: "success",
          title: response.data.message,
        }).then(() => {
          staffFatch();
        });
      } else {
        SweetAlertShow("info", "Warning", response.data.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err.message,
      );
    }
  };

  useEffect(() => {
    staffFatch();
  }, [id]);

  const [permissions, setPermissions] = useState([]);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    const userPermissions = localStorage.getItem("user_permissions");
    const parsedPermissions = userPermissions
      ? JSON.parse(userPermissions)
      : null;

    setPermissions(parsedPermissions?.permissions ?? []);

    // NOTE: adjust `role_id` / `permission_id` below to match whatever key
    // actually holds the role identifier in your stored object.
    const roleId = parsedPermissions?.id;

    setIsSuperAdmin(Number(roleId) === 1);
  }, []);

  if (loading) return <p>Loading...</p>;
  if (!teacher) return <p>No teacher data found</p>;
  return (
    <div>
      {/* Month Salary */}

      <div className="card border-0 shadow-sm mb-4">
        <div className="card-header bg-white border-0 py-3">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
            <div>
              <h4 className="mb-1 fw-bold">Monthly Salary Report</h4>

              <small className="text-muted">Salary generated month wise</small>
            </div>

            <div className="d-flex flex-column flex-md-row gap-2 mt-3 mt-md-0">

              {hasAccess("/staff/salary/generate") && (
                <button
                  className="btn btn-primary mt-3 mt-md-0"
                  data-bs-toggle="modal"
                  data-bs-target="#add_month_salary"
                  onClick={() =>
                    setModalData({
                      staff_id: teacher?.id,
                      month: "",
                      total_working_days: "",
                      present_days: "",
                    })
                  }
                >
                  <i className="ri-add-line me-2"></i>
                  Generate Salary
                </button>
              )}
              {hasAccess("/staff/dashboard/view/report") && (

                <button
                  className="btn btn-primary"
                  onClick={() =>
                    navigate("/staff/report/dashboard", {
                      state: {
                        staffId: teacher.id,
                      },
                    })
                  }
                >
                  <i className="ri-money-rupee-circle-line me-1"></i>
                  Salary Report
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table align-middle table-hover">
              <thead className="table-light">
                <tr>
                  <th>Month</th>

                  <th>Earned</th>

                  <th>Paid</th>

                  <th>Pending</th>

                  <th>Attendance</th>

                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {teacher?.salaries?.length ? (
                  teacher.salaries.map((sal) => {
                    const pending = Number(sal.pending_amount) > 0;

                    return (
                      <tr key={sal.id}>
                        <td>
                          <div className="fw-semibold">
                            {new Date(sal.year, sal.month - 1).toLocaleString(
                              "default",
                              {
                                month: "long",
                              },
                            )}
                          </div>

                          <small className="text-muted">{sal.year}</small>
                        </td>

                        <td>
                          <div className="d-flex flex-column">
                            <span className="fw-bold text-primary">
                              ₹
                              {Number(sal.earned_salary).toLocaleString(
                                "en-IN",
                              )}
                            </span>

                            {sal.old_earned_salary &&
                              Number(sal.old_earned_salary) > 0 &&
                              Number(sal.old_earned_salary) !==
                              Number(sal.earned_salary) && (
                                <div className="d-flex align-items-center gap-1">
                                  <small
                                    className="text-danger text-decoration-line-through"
                                    title="Previous Earned Salary"
                                  >
                                    ₹
                                    {Number(
                                      sal.old_earned_salary,
                                    ).toLocaleString("en-IN")}
                                  </small>

                                  {sal.remark && (
                                    <i
                                      className="ri-information-line text-muted"
                                      role="button"
                                      title={sal.remark}
                                      style={{
                                        fontSize: "14px",
                                        cursor: "pointer",
                                      }}
                                    ></i>
                                  )}
                                </div>
                              )}
                          </div>
                        </td>

                        <td>
                          <span className="text-success fw-semibold">
                            ₹{Number(sal.paid_amount).toLocaleString("en-IN")}
                          </span>
                        </td>

                        <td>
                          <span className="text-danger fw-semibold">
                            ₹
                            {Number(sal.pending_amount).toLocaleString("en-IN")}
                          </span>
                        </td>

                        <td>
                          <div>
                            <span className="badge rounded-pill bg-label-success me-2">
                              {sal.present_days}
                            </span>

                            <span className="badge rounded-pill bg-label-danger">
                              {sal.leave_days}
                            </span>
                          </div>
                        </td>

                        <td>
                          {pending ? (
                            <span className="badge rounded-pill bg-label-warning">
                              Pending
                            </span>
                          ) : (
                            <span className="badge rounded-pill bg-label-success">
                              Paid
                            </span>
                          )}
                        </td>

                        <td className="text-center">
                          {pending && !(Number(sal.old_earned_salary) > 0) ? (
                            <i
                              className="ri-edit-line text-primary"
                              role="button"
                              title="Edit Earned Salary"
                              data-bs-toggle="modal"
                              data-bs-target="#earned_salary_update"
                              style={{ fontSize: "18px", cursor: "pointer" }}
                              onClick={() =>
                                setEarnedSalaryData({
                                  staff_id: teacher.id,
                                  staff_salary_id: sal.id,
                                  new_earned_salary: sal.earned_salary,
                                  old_earned_salary: sal.earned_salary,
                                  old_working_days: sal.working_days,
                                  new_working_days: sal.working_days,
                                  old_present_days: sal.present_days,
                                  new_present_days: sal.present_days,
                                  remark: "",
                                })
                              }
                            ></i>
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-5">
                      <i
                        className="ri-wallet-3-line text-secondary"
                        style={{
                          fontSize: 55,
                        }}
                      ></i>

                      <h5 className="mt-3">No Salary Generated</h5>

                      <p className="text-muted mb-0">
                        Generate monthly salary to see records.
                      </p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* staff_expense */}
      <div className="card border-0 shadow-sm">
        <div className="card-header bg-white border-0">
          <h4 className="fw-bold mb-1">Transaction History</h4>

          <small className="text-muted">All salary payments</small>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Date</th>

                  <th>Amount</th>

                  <th>Bank</th>

                  <th>Description</th>
                </tr>
              </thead>

              <tbody>
                {teacher?.transactions?.length ? (
                  teacher.transactions.map((txn) => (
                    <tr key={txn.id}>
                      <td>
                        <div className="fw-semibold">
                          {new Intl.DateTimeFormat("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }).format(new Date(txn.date))}
                        </div>
                      </td>

                      <td>
                        <span className="fw-bold text-success">
                          ₹{Number(txn.amount).toLocaleString("en-IN")}
                        </span>
                      </td>

                      <td>
                        <div>
                          <i className="ri-bank-line me-2 text-primary"></i>

                          {txn.bank?.owner_name || "-"}
                        </div>
                      </td>

                      <td>{txn.description || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-5">
                      <i
                        className="ri-exchange-dollar-line text-secondary"
                        style={{
                          fontSize: 55,
                        }}
                      ></i>

                      <h5 className="mt-3">No Transactions</h5>

                      <p className="text-muted mb-0">
                        No payment transactions available.
                      </p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Transaction Info
      <div className="card mb-4">
        <h5 className="card-header">Transaction History</h5>
        <div className="card-body">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Amount</th>
                <th>Payment Method</th>
                <th>Transaction ID</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {teacher?.staff_transactions?.length > 0 ? (
                teacher.staff_transactions.map((txn, index) => (
                  <tr key={txn.id}>
                    <td>{index + 1}</td>
                    <td>₹{txn.amount}</td>
                    <td>{txn.payment_method}</td>
                    <td>{txn.trans_id}</td>
                    <td>
                      {txn.status === "1" ? (
                        <span className="badge bg-success">Success</span>
                      ) : (
                        <span className="badge bg-danger">Failed</span>
                      )}
                    </td>
                    <td>{new Date(txn.created_at).toLocaleString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No transactions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div> */}

      <div
        className="modal fade"
        id="salary_update"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form action="" onSubmit={handleSalaryChange}>
              <div className="modal-header py-3 bg-label-primary">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Salary Update
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="row g-4">
                  <input
                    type="hidden"
                    name="id"
                    id="id"
                    value={modalData?.id}
                  />
                  <input
                    type="hidden"
                    name="staff_id"
                    id="staff_id"
                    value={modalData?.staff_id}
                  />

                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="date"
                        className="form-control"
                        name="joining_date"
                        id="joining_date"
                        value={modalData?.joining_date}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            joining_date: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="joining_date">Joining Date</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <select
                        name="salary_type"
                        id="salary_type"
                        className="form-control"
                        value={modalData?.salary_type}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            salary_type: e.target.value,
                          }))
                        }
                      >
                        <option value="" selected disabled>
                          Select Salary Type
                        </option>
                        <option value="Monthly">Monthly</option>
                        <option value="Hourly">Hourly</option>
                      </select>
                      <label htmlFor="">Salary Type</label>
                    </div>
                  </div>
                  {modalData?.salary_type == "Monthly" && (
                    <div className="col-md-6">
                      <div className=" form-floating form-floating-outline ">
                        <select
                          name="working_schedule_id"
                          id="working_schedule_id"
                          className="form-control"
                          value={modalData?.working_schedule_id}
                          onChange={(e) =>
                            setModalData((prev) => ({
                              ...prev,
                              working_schedule_id: e.target.value,
                            }))
                          }
                        >
                          <option value="" selected disabled>
                            Select Working Schedule
                          </option>
                          {workingSchedules?.map((schedule, i) => (
                            <option key={i} value={schedule?.id}>
                              {schedule?.name} (
                              {formatTime(schedule?.start_time)}-
                              {formatTime(schedule?.end_time)})
                            </option>
                          ))}
                        </select>
                        <label htmlFor="working_schedule_id">
                          Working Schedule
                        </label>
                      </div>
                    </div>
                  )}
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="number"
                        className="form-control"
                        name="total_hours_per_day"
                        id="total_hours_per_day"
                        value={modalData?.total_hours_per_day}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            total_hours_per_day: e.target.value,
                          }))
                        }
                        readOnly={
                          modalData?.salary_type == "Monthly" &&
                            modalData?.working_schedule_id
                            ? true
                            : false
                        }
                        placeholder="Working Hours Per Day"
                      />
                      <label htmlFor="total_hours_per_day">
                        Working Hours Per Day
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="number"
                        className="form-control"
                        name="current_salary"
                        id="current_salary"
                        placeholder="Salary"
                        value={modalData?.current_salary}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            current_salary: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="current_salary">Salary</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="number"
                        className="form-control"
                        name="current_overtime_rate"
                        id="current_overtime_rate"
                        placeholder="Overtime Rate (Per Hours)"
                        value={modalData?.current_overtime_rate}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            current_overtime_rate: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="current_overtime_rate">
                        Overtime Rate (Per Hours)
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="number"
                        className="form-control"
                        name="paid_leaves_per_month"
                        id="paid_leaves_per_month"
                        placeholder="Paid Leaves Per Month"
                        value={modalData?.paid_leaves_per_month}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            paid_leaves_per_month: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="paid_leaves_per_month">
                        Paid Leaves Per Month
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline">
                      <select
                        name="carry_forward"
                        id="carry_forward"
                        className="form-select"
                        value={modalData?.carry_forward}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            carry_forward: e.target.value,
                          }))
                        }
                      >
                        <option value="2">No</option>
                        <option value="1">Yes</option>
                      </select>
                      <label htmlFor="carry_forward">
                        Paid Leaves Carry Forward
                      </label>
                    </div>
                  </div>
                  {modalData?.carry_forward == "1" && (
                    <div className="col-md-6">
                      <div className=" form-floating form-floating-outline ">
                        <input
                          type="number"
                          className="form-control"
                          name="max_carry_forward"
                          id="max_carry_forward"
                          placeholder=" Maximum Paid Leaves Carry Forward"
                          value={modalData?.max_carry_forward}
                          onChange={(e) =>
                            setModalData((prev) => ({
                              ...prev,
                              max_carry_forward: e.target.value,
                            }))
                          }
                        />
                        <label htmlFor="max_carry_forward">
                          Maximum Paid Leaves Carry Forward
                        </label>
                      </div>
                    </div>
                  )}
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <textarea
                        type="text"
                        className="form-control input-uppercase"
                        name="remarks"
                        id="remarks"
                        placeholder="Remark"
                        value={modalData?.remarks}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            remarks: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="remarks">Remark</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <textarea
                        type="text"
                        className="form-control input-uppercase"
                        name="reason"
                        id="reason"
                        placeholder="Reason for Change"
                      />
                      <label htmlFor="reason">Reason for Change</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="date"
                        className="form-control"
                        name="effective_from"
                        id="effective_from"
                        min={
                          modalData?.joining_date
                            ? new Date(modalData.joining_date)
                              .toISOString()
                              .split("T")[0]
                            : ""
                        }
                      />

                      <label htmlFor="effective_from">Effective From</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="file"
                        className="form-control"
                        name="joining_img"
                        id="joining_img"
                      />
                      <label htmlFor="joining_img">Joining Later Img</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="add_month_salary"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <form onSubmit={AddMonthSalary}>
              <div className="modal-header py-3 bg-label-primary">
                <h5 className="modal-title">Add Salary</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                />
              </div>

              <input type="hidden" name="staff_id" value={teacher?.id} />

              <div className="modal-body">
                <div className="row g-4">
                  {/* Month */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="month"
                        name="month"
                        className="form-control"
                        defaultValue={modalData?.month}
                      />
                      <label>Month</label>
                      <span className="text-danger">{error?.month ?? ""}</span>
                    </div>
                  </div>

                  {/* Total Days */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="total_working_days"
                        className="form-control"
                        placeholder="Total Days"
                        defaultValue={modalData?.total_woeking_days}
                      />
                      <label>Total Working Days</label>
                      <span className="text-danger">
                        {error?.total_days ?? ""}
                      </span>
                    </div>
                  </div>

                  {/* Present Days */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="present_days"
                        className="form-control"
                        placeholder="Present Days"
                        defaultValue={modalData?.present_days}
                      />
                      <label>Present Days</label>
                      <span className="text-danger">
                        {error?.present_days ?? ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* FOOTER */}
              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>

                <button type="submit" className="btn btn-primary">
                  Save Salary
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Earned Salary Update Modal - now with working/present days (old value shown) + remark */}
      <div
        className="modal fade"
        id="earned_salary_update"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form onSubmit={handleEarnedSalaryUpdate}>
              <div className="modal-header bg-label-primary">
                <h5 className="modal-title">Update Earned Salary</h5>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                />
              </div>

              <div className="modal-body">
                <input type="hidden" value={earnedSalaryData.staff_id} />

                <input type="hidden" value={earnedSalaryData.staff_salary_id} />

                <div className="row g-4">
                  {/* Earned Salary */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        className="form-control"
                        value={earnedSalaryData.new_earned_salary}
                        onChange={(e) =>
                          setEarnedSalaryData((prev) => ({
                            ...prev,
                            new_earned_salary: e.target.value,
                          }))
                        }
                      />

                      <label>Earned Salary</label>
                    </div>
                    {earnedSalaryData.old_earned_salary !== "" && (
                      <small className="text-muted">
                        Old: ₹
                        {Number(
                          earnedSalaryData.old_earned_salary,
                        ).toLocaleString("en-IN")}
                      </small>
                    )}
                  </div>

                  {/* Working Days - editable only for super admin */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Working Days"
                        value={earnedSalaryData.new_working_days}
                        disabled={!isSuperAdmin}
                        onChange={(e) =>
                          setEarnedSalaryData((prev) => ({
                            ...prev,
                            new_working_days: e.target.value,
                          }))
                        }
                      />

                      <label>Working Days</label>
                    </div>
                    {earnedSalaryData.old_working_days !== "" && (
                      <small className="text-muted">
                        Old: {earnedSalaryData.old_working_days}
                      </small>
                    )}
                    {!isSuperAdmin && (
                      <small className="text-warning d-block">
                        Only super admin can update working days
                      </small>
                    )}
                  </div>

                  {/* Present Days - editable only for super admin */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Present Days"
                        value={earnedSalaryData.new_present_days}
                        disabled={!isSuperAdmin}
                        onChange={(e) =>
                          setEarnedSalaryData((prev) => ({
                            ...prev,
                            new_present_days: e.target.value,
                          }))
                        }
                      />

                      <label>Present Days</label>
                    </div>
                    {earnedSalaryData.old_present_days !== "" && (
                      <small className="text-muted">
                        Old: {earnedSalaryData.old_present_days}
                      </small>
                    )}
                    {!isSuperAdmin && (
                      <small className="text-warning d-block">
                        Only super admin can update present days
                      </small>
                    )}
                  </div>

                  {/* Remark */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <textarea
                        className="form-control"
                        placeholder="Remark"
                        style={{ minHeight: "100px" }}
                        value={earnedSalaryData.remark}
                        onChange={(e) =>
                          setEarnedSalaryData((prev) => ({
                            ...prev,
                            remark: e.target.value,
                          }))
                        }
                      />

                      <label>Remark</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>

                <button type="submit" className="btn btn-primary">
                  Update Salary
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleryInfoTab;
